module.exports = __webpack_public_path__ + "img/icon-usp-greeting-card.aa91e20c.svg";